var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 577,
    viewBox: "0 0 150 577",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9994 180.5L73.1993 144.4L109.299 180.5L145.499 144.4V180.5L109.299 216.5L73.1993 180.5L36.9994 216.5L0.899414 180.5V144.4L36.9994 180.5Z",
    fill: "#6363A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1993 216.5L109.299 252.6L145.499 216.5V252.6L109.299 288.6L73.1993 252.6L36.9994 288.6L0.899414 252.6V216.5L36.9994 252.6L73.1993 216.5Z",
    fill: "#E96345"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 432.7H145.499V577H0.899414V432.7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.7 555.9C121.8 555.9 124.3 553.3 124.3 550.2C124.3 547.1 121.8 544.6 118.7 544.6C115.6 544.6 113 547.1 113 550.2C113 553.3 115.6 555.9 118.7 555.9Z",
    fill: "#FABD29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8998 555.9C98.9998 555.9 101.6 553.3 101.6 550.2C101.6 547.1 98.9998 544.6 95.8998 544.6C92.7998 544.6 90.2998 547.1 90.2998 550.2C90.2998 553.3 92.7998 555.9 95.8998 555.9Z",
    fill: "#FABD29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2 555.9C76.3 555.9 78.8 553.3 78.8 550.2C78.8 547.1 76.3 544.6 73.2 544.6C70.1 544.6 67.5 547.1 67.5 550.2C67.5 553.3 70.1 555.9 73.2 555.9Z",
    fill: "#FABD29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3998 555.9C53.4998 555.9 56.0997 553.3 56.0997 550.2C56.0997 547.1 53.4998 544.6 50.3998 544.6C47.2998 544.6 44.7998 547.1 44.7998 550.2C44.7998 553.3 47.2998 555.9 50.3998 555.9Z",
    fill: "#FABD29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 544.6C24.6 544.6 22 547.1 22 550.2C22 553.3 24.6 555.9 27.7 555.9C30.8 555.9 33.3 553.3 33.3 550.2C33.3 547.1 30.8 544.6 27.7 544.6Z",
    fill: "#FABD29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.7 533.2C121.8 533.2 124.3 530.7 124.3 527.6C124.3 524.4 121.8 521.9 118.7 521.9C115.6 521.9 113 524.4 113 527.6C113 530.7 115.6 533.2 118.7 533.2Z",
    fill: "#FABD29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8998 533.2C98.9998 533.2 101.6 530.7 101.6 527.6C101.6 524.4 98.9998 521.9 95.8998 521.9C92.7998 521.9 90.2998 524.4 90.2998 527.6C90.2998 530.7 92.7998 533.2 95.8998 533.2Z",
    fill: "#FABD29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2 533.2C76.3 533.2 78.8 530.7 78.8 527.6C78.8 524.4 76.3 521.9 73.2 521.9C70.1 521.9 67.5 524.4 67.5 527.6C67.5 530.7 70.1 533.2 73.2 533.2Z",
    fill: "#FABD29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3998 533.2C53.4998 533.2 56.0997 530.7 56.0997 527.6C56.0997 524.4 53.4998 521.9 50.3998 521.9C47.2998 521.9 44.7998 524.4 44.7998 527.6C44.7998 530.7 47.2998 533.2 50.3998 533.2Z",
    fill: "#FABD29"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 533.2C30.8 533.2 33.3 530.7 33.3 527.6C33.3 524.4 30.8 521.9 27.7 521.9C24.6 521.9 22 524.4 22 527.6C22 530.7 24.6 533.2 27.7 533.2Z",
    fill: "#FABD29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.7 510.5C121.8 510.5 124.3 508 124.3 504.9C124.3 501.8 121.8 499.2 118.7 499.2C115.6 499.2 113 501.8 113 504.9C113 508 115.6 510.5 118.7 510.5Z",
    fill: "#FABD29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8998 510.5C98.9998 510.5 101.6 508 101.6 504.9C101.6 501.8 98.9998 499.2 95.8998 499.2C92.7998 499.2 90.2998 501.8 90.2998 504.9C90.2998 508 92.7998 510.5 95.8998 510.5Z",
    fill: "#FABD29"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2 510.5C76.3 510.5 78.8 508 78.8 504.9C78.8 501.8 76.3 499.2 73.2 499.2C70.1 499.2 67.5 501.8 67.5 504.9C67.5 508 70.1 510.5 73.2 510.5Z",
    fill: "#FABD29"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3998 510.5C53.4998 510.5 56.0997 508 56.0997 504.9C56.0997 501.8 53.4998 499.2 50.3998 499.2C47.2998 499.2 44.7998 501.8 44.7998 504.9C44.7998 508 47.2998 510.5 50.3998 510.5Z",
    fill: "#FABD29"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 510.5C30.8 510.5 33.3 508 33.3 504.9C33.3 501.8 30.8 499.2 27.7 499.2C24.6 499.2 22 501.8 22 504.9C22 508 24.6 510.5 27.7 510.5Z",
    fill: "#FABD29"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M118.7 487.8C121.8 487.8 124.3 485.3 124.3 482.2C124.3 479.1 121.8 476.5 118.7 476.5C115.6 476.5 113 479.1 113 482.2C113 485.3 115.6 487.8 118.7 487.8Z",
    fill: "#FABD29"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8998 487.8C98.9998 487.8 101.6 485.3 101.6 482.2C101.6 479.1 98.9998 476.5 95.8998 476.5C92.7998 476.5 90.2998 479.1 90.2998 482.2C90.2998 485.3 92.7998 487.8 95.8998 487.8Z",
    fill: "#FABD29"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2 487.8C76.3 487.8 78.8 485.3 78.8 482.2C78.8 479.1 76.3 476.5 73.2 476.5C70.1 476.5 67.5 479.1 67.5 482.2C67.5 485.3 70.1 487.8 73.2 487.8Z",
    fill: "#FABD29"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3998 487.8C53.4998 487.8 56.0997 485.3 56.0997 482.2C56.0997 479.1 53.4998 476.5 50.3998 476.5C47.2998 476.5 44.7998 479.1 44.7998 482.2C44.7998 485.3 47.2998 487.8 50.3998 487.8Z",
    fill: "#FABD29"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 487.8C30.8 487.8 33.3 485.3 33.3 482.2C33.3 479.1 30.8 476.5 27.7 476.5C24.6 476.5 22 479.1 22 482.2C22 485.3 24.6 487.8 27.7 487.8Z",
    fill: "#FABD29"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M118.7 465.1C121.8 465.1 124.3 462.6 124.3 459.5C124.3 456.4 121.8 453.9 118.7 453.9C115.6 453.9 113 456.4 113 459.5C113 462.6 115.6 465.1 118.7 465.1Z",
    fill: "#FABD29"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8998 465.1C98.9998 465.1 101.6 462.6 101.6 459.5C101.6 456.4 98.9998 453.9 95.8998 453.9C92.7998 453.9 90.2998 456.4 90.2998 459.5C90.2998 462.6 92.7998 465.1 95.8998 465.1Z",
    fill: "#FABD29"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2 465.1C76.3 465.1 78.8 462.6 78.8 459.5C78.8 456.4 76.3 453.9 73.2 453.9C70.1 453.9 67.5 456.4 67.5 459.5C67.5 462.6 70.1 465.1 73.2 465.1Z",
    fill: "#FABD29"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3998 465.1C53.4998 465.1 56.0997 462.6 56.0997 459.5C56.0997 456.4 53.4998 453.9 50.3998 453.9C47.2998 453.9 44.7998 456.4 44.7998 459.5C44.7998 462.6 47.2998 465.1 50.3998 465.1Z",
    fill: "#FABD29"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 465.1C30.8 465.1 33.3 462.6 33.3 459.5C33.3 456.4 30.8 453.9 27.7 453.9C24.6 453.9 22 456.4 22 459.5C22 462.6 24.6 465.1 27.7 465.1Z",
    fill: "#FABD29"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 0H145.499V144.2H0.899414V0Z",
    fill: "#064DA1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2002 40.2001C90.2002 41.5001 103.9 55.1001 105.2 72.1001H105.3C106.7 55.1001 120.3 41.5001 137.3 40.2001V40.1001C120.3 38.8001 106.7 25.2001 105.3 8.1001H105.2C103.9 25.2001 90.2002 38.8001 73.2002 40.1001V40.2001Z",
    fill: "#77B75A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9 40.2001C26.1 41.5001 39.7 55.1001 41 72.1001H41.2C42.5 55.1001 56.1 41.5001 73.2 40.2001V40.1001C56.1 38.8001 42.5 25.2001 41.2 8.1001H41C39.7 25.2001 26.1 38.8001 9 40.1001V40.2001Z",
    fill: "#77B75A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2002 104.2C90.2002 105.5 103.9 119.1 105.2 136.1H105.3C106.7 119.1 120.3 105.5 137.3 104.2V104.1C120.3 102.8 106.7 89.2001 105.3 72.1001H105.2C103.9 89.2001 90.2002 102.8 73.2002 104.1V104.2Z",
    fill: "#77B75A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9 104.2C26.1 105.5 39.7 119.1 41 136.1H41.2C42.5 119.1 56.1 105.5 73.2 104.2V104.1C56.1 102.8 42.5 89.2001 41.2 72.1001H41C39.7 89.2001 26.1 102.8 9 104.1V104.2Z",
    fill: "#77B75A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2 431.3H286.7V145.8L2 431.3Z",
    fill: "#F2F6FC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2 289.4V432.1H144.3V289.4H2Z",
    fill: "#DCE4EF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 360.7C42.9 377.6 56.3 391 73.2 392.3V392.5C56.3 393.8 42.9 407.2 41.7 424.1H41.5C40.3 407.2 26.9 393.8 10 392.5V392.3C26.9 391 40.3 377.6 41.5 360.7H41.7Z",
    fill: "#064DA1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7 297.4C42.9 314.2 56.3 327.7 73.2 329V329.2C56.3 330.5 42.9 343.9 41.7 360.7H41.5C40.3 343.9 26.9 330.5 10 329.2V329C26.9 327.7 40.3 314.2 41.5 297.4H41.7Z",
    fill: "#064DA1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8 360.7C106.1 377.6 119.5 391 136.3 392.3V392.5C119.5 393.8 106.1 407.2 104.8 424.1H104.7C103.4 407.2 90.0002 393.8 73.2002 392.5V392.3C90.0002 391 103.4 377.6 104.7 360.7H104.8Z",
    fill: "#064DA1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8 297.4C106.1 314.2 119.5 327.7 136.3 329V329.2C119.5 330.5 106.1 343.9 104.8 360.7H104.7C103.4 343.9 90.0002 330.5 73.2002 329.2V329C90.0002 327.7 103.4 314.2 104.7 297.4H104.8Z",
    fill: "#064DA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFlags);
export default __webpack_public_path__ + "static/media/right_flags.29e9f06a842aeebb6d24f7c9733e9c09.svg";
export { ForwardRef as ReactComponent };